import React, { useEffect, useState } from 'react'
import { DatePicker, Select, Button, Table, Spin, Tooltip } from 'antd'
import moment from 'moment'
import { InfoCircleOutlined } from '@ant-design/icons'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'

const { RangePicker, Avatar } = DatePicker

const mainData = [
  {
    key: '1',
    children: [
      {
        key: '1-1',
        date: '2 June 2025',
        hour: '12 AM',
        activity: 'Jump 10 meter',
        status: 'Pending',
      },
    ],
  },
  {
    key: '2',
    children: [
      {
        key: '2-1',
        date: '3 June 2025',
        hour: '12 AM',
        activity: 'Look for friends',
        status: 'Pending',
      },
      {
        key: '2-2',
        date: '',
        hour: '12 AM',
        activity: 'Go for swim',
        status: 'Pending',
      },
    ],
  },
]

const timeZones = [
  {
    value: '-5',
    label: '-5',
  },
  {
    value: '-6',
    label: '-6',
  },
  {
    value: '+5',
    label: '+5',
  },
  {
    value: '+6',
    label: '+6',
  },
]

function UserData() {
  const [loading, setLoading] = useState(false)
  const [organizations, setOrganizations] = useState([])
  const [selectedOrg, setSelectedOrg] = useState('')
  const [orgMembers, setoOrgMembers] = useState([])
  const [selectedMember, setSelectedMember] = useState('')
  const [data, setData] = useState(null)
  const [calculations, setCalculations] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [timeZone, setTimeZone] = useState(timeZones[0].value)

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Hour',
      dataIndex: 'hour',
      key: 'hour',
    },
    {
      title: 'First name',
      dataIndex: 'createdByFirstName',
      key: 'createdByFirstName',
      render: (_, record) => (
        <div
          onClick={() => {
            window.open(`/member/${record.userId}`, '_blank')
          }}
          style={{ cursor: 'pointer' }}
        >
          {record.createdByFirstName}
        </div>
      ),
    },
    {
      title: 'Last name',
      dataIndex: 'createdByLastName',
      key: 'createdByLastName',
      render: (_, record) => (
        <div
          onClick={() => {
            window.open(`/member/${record.userId}`, '_blank')
          }}
          style={{ cursor: 'pointer' }}
        >
          {record.createdByLastName}
        </div>
      ),
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Focus Area',
      dataIndex: 'focusArea',
      key: 'focusArea',
    },
    {
      title: 'Activity',
      dataIndex: 'activity',
      key: 'activity',
    },
    {
      title: (
        <span style={{ display: 'flex', gap: 3 }}>
          Reps{' '}
          <Tooltip title="The rep count reflects the total number of times this user has performed the activity within the platform.">
            <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
          </Tooltip>
        </span>
      ),
      dataIndex: 'reps',
      key: 'reps',
    },
    {
      title: 'Points',
      dataIndex: 'points',
      key: 'points',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
  ]

  const getMyInfo = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/admin/me`)

      // Check the admin organizations
      if (response?.data?.user?.organizations && response?.data?.user?.organizations.length > 0) {
        const org = response.data.user.organizations
        // console.log(org)

        // store to render at JSX
        org.forEach((element, idx) => {
          if (idx == 0) setSelectedOrg(element._id) // auto selecting the first organization to fetch some results
          setOrganizations((prevElements) => [
            ...prevElements,
            {
              value: element._id,
              label: element.name,
            },
          ])
        })
      }

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const getData = async (id) => {
    try {
      // console.log(id)

      if (!startDate || !endDate) {
        console.log(startDate, endDate)
        return
      }

      setLoading(true)

      const payload = {
        timeZone,
        startDate,
        endDate,
        summaryOfClub: selectedOrg,
        userId: id,
      }

      // console.log(payload)

      const response = await axiosInstance.post(`/api/v1/metrics/userDataPage`, payload)

      // console.log(response.data)

      setData(response.data?.results)

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const handleRangePicker = (value) => {
    // console.log('Selected Time: ', value)
    value?.map((el, idx) => {
      // console.log(moment(new Date(el)).format('MMMM DD, YYYY h:mm:ss a')) // Readable format
      // console.log(new Date(el).getTime()) // Epoch timestamp in miliseconds
      let start = 0
      let end = 0
      if (idx == 0) {
        start = new Date(el).getTime()
        setStartDate(start)
      } else if (idx == 1) {
        end = new Date(el).getTime()
        setEndDate(end)
      }
      console.log(start)
      console.log(end)
    })
  }

  const getAClubMembers = async (id) => {
    try {
      setLoading(true)

      setoOrgMembers([])

      const response = await axiosInstance.get(`/api/v1/admin/getAClubMembers?clubId=${id}`)

      response.data.users.forEach((element) => {
        setoOrgMembers((prevElements) => [
          ...prevElements,
          {
            value: element._id,
            label: element.firstName + ' ' + element.lastName,
          },
        ])
      })

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    getMyInfo()
  }, [])

  useEffect(() => {
    if (selectedOrg) {
      getAClubMembers(selectedOrg)
    }
  }, [selectedOrg])

  useEffect(() => {
    // console.log('selectedMember')
    // console.log(selectedMember)
    if (selectedMember) {
      if (selectedMember) {
        getData(selectedMember)
      }
    }
  }, [selectedMember])

  if (organizations.length == 0) return null

  return (
    <Layout>
      <h1>User Data</h1>
      <Select
        placeholder="Please select club or business"
        style={{ width: 250 }}
        defaultValue={organizations[0].value}
        onChange={(value) => setSelectedOrg(value)}
        options={organizations}
      />
      <RangePicker onChange={handleRangePicker} />
      {orgMembers.length && (
        <Select
          placeholder="Select a member (Optional)"
          style={{ width: 250 }}
          onChange={(value) => {
            console.log(value)
            setSelectedMember(value)
          }}
          options={orgMembers}
          showSearch
          filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          allowClear
        />
      )}
      <Select placeholder="Please select timezone" style={{ width: 100 }} defaultValue={timeZones[0].value} onChange={(value) => setTimeZone(value)} options={timeZones} />

      <Button type="primary" style={{ cursor: 'pointer' }} onClick={() => getData(selectedMember)} loading={loading}>
        Get data
      </Button>
      <br />
      <br />
      <div style={{ marginTop: 10 }}></div>
      {data?.length > 0 && !loading ? (
        <Table columns={columns} dataSource={data} pagination={false} bordered expandable={{ defaultExpandAllRows: true }} />
      ) : (
        <>{loading ? <Spin size="large" /> : <p style={{ color: '#c4c4c4' }}>Please change query combination to get expected data.</p>}</>
      )}
    </Layout>
  )
}

export default UserData
